import { render, staticRenderFns } from "./indexBis.vue?vue&type=template&id=2562e3a2&"
import script from "./indexBis.vue?vue&type=script&lang=js&"
export * from "./indexBis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports